// Styles for Quote go here.
import styled, { css } from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';

const RTL_REVERSE_QUOTES = '"\u201D" "\u201C"';

const hiddenQuoteMarks = css`
  quotes: none;

  &::before,
  &::after {
    content: none;
  }
`;

export const StyledQuote = styled.div<{ $hideQuotationMarks: boolean }>`
  q {
    ${({ $hideQuotationMarks }) => ($hideQuotationMarks ? hiddenQuoteMarks : 'quotes: auto;')}
  }

  .luxury-quote {
    padding: ${toRem(64)} 0;
    align-items: center;
    p {
      margin-bottom: 0;
      display: inline;
    }

    .luxury-quote-image {
      width: 100%;
      aspect-ratio: 2/3;
    }
  }

  [dir='rtl'] & {
    q.reverse-quotes {
      ${({ $hideQuotationMarks }) =>
        $hideQuotationMarks
          ? hiddenQuoteMarks
          : css`
              quotes: ${RTL_REVERSE_QUOTES};
            `}
    }
    .right-ar-image {
      margin-right: 0;
    }
    .left-ar-text {
      margin-right: 0;
    }
  }
`;
